import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LogoScroller from "../components/LogoScroller";

// Header component for the homepage hero section
const HomeHeader = () => {
  const { t, i18n } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === "en" ? "es" : "en");
  };
  return (
    <header className="page-header hero-header">
      <div className="band-name">
        <Link to="/">{t("bandName")}</Link>
      </div>

      {/* 1. Moved the <nav> element BEFORE the button */}
      <nav className={`page-nav ${isMenuOpen ? "menu-open" : ""}`}>
        <ul>
          <li>
            <Link to="/music">{t("navMusic")}</Link>
          </li>
          <li>
            <Link to="/contact">{t("navContact")}</Link>
          </li>
          <li>
            <Link to="/booking">{t("navBookMe")}</Link>
          </li>
          <li>
            <button onClick={toggleLanguage} className="lang-switch">
              {i18n.language === "en" ? "Español" : "English"}
            </button>
          </li>
        </ul>
      </nav>

      {/* 2. Added the "active" class and moved the button to be the last element */}
      <button
        className={`hamburger-menu ${isMenuOpen ? "active" : ""}`}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </button>
    </header>
  );
};

// Footer component for the home page
const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="site-footer">
      <p>{t("footerRights")}</p>
    </footer>
  );
};

// Main Home component with the new structure
const Home = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* === HERO VIDEO SECTION === */}
      <section className="hero-section">
        <video autoPlay loop muted playsInline className="hero-video">
          <source src="/assets/videos/B_Roll_Guitar.mov" type="video/mp4" />
        </video>
        <HomeHeader />
        <div className="hero-main-content">
          <h1>{t("heroTitle")}</h1>
        </div>
      </section>

      {/* === MUSIC PLAYER SECTION === */}
      <section className="page-preview" id="music-preview">
        <h2 className="section-title">{t("musicPreviewTitle")}</h2>

        <div className="album-grid">
          {/* Album 1 */}
          <div className="album-item">
            <img
              src="/assets/images/album-punto-final.png"
              alt="Punto Final album cover"
            />
            <a
              href="https://youtu.be/mWZkZ3cW8Pg?si=CjYkNKl947kYACE-"
              target="_blank"
              rel="noopener noreferrer"
              className="listen-now-btn"
            >
              {t("listenNow")}
            </a>
          </div>

          {/* Album 2 (Replace with your image) */}
          <div className="album-item">
            <img
              src="/assets/images/album-de-dia-y-de-noche.jpg"
              alt="De Día y De Noche album cover"
            />
            <a
              href="https://youtu.be/IQTIxQSEu6s?si=TBDE3EN8ltZIxp4p"
              target="_blank"
              rel="noopener noreferrer"
              className="listen-now-btn"
            >
              {t("listenNow")}
            </a>
          </div>

          {/* Album 3 (Replace with your image) */}
          <div className="album-item">
            <img
              src="/assets/images/album-loco-de-amor.jpg"
              alt="Loco De Amor album cover"
            />
            <a
              href="https://youtu.be/tnlmlTfjyjo?si=PTXadBq9VjMNRPuo"
              target="_blank"
              rel="noopener noreferrer"
              className="listen-now-btn"
            >
              {t("listenNow")}
            </a>
          </div>
        </div>
        <LogoScroller />
      </section>

      {/* === CONTACT & SOCIALS SECTION === */}
      <section className="page-preview" id="contact-preview">
        <h2 className="section-title">{t("contactPreviewTitle")}</h2>
        <div className="contact-methods-grid">
          <a
            href="https://www.instagram.com/marinoflores_official/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/assets/images/instagram_logo.png" alt="Instagram" />
            <span>Instagram</span>
          </a>
          <a
            href="https://www.tiktok.com/@marino_flores_oficial"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/assets/images/tiktok_logo.png" alt="TikTok" />
            <span>TikTok</span>
          </a>
          <a href="https://www.facebook.com/profile.php?id=100085332877541">
            <img src="/assets/images/facebook_logo.png" alt="Call Us" />
            <span>Facebook</span>
          </a>
          <a href="tel:831-667-8287">
            <img src="/assets/images/whatsapp_logo.png" alt="Text Us" />
            <span>Phone Number</span>
          </a>
        </div>
      </section>

      {/* === BOOKING SECTION === */}
      <section className="page-preview" id="booking-preview">
        <h2 className="section-title">{t("bookingPreviewTitle")}</h2>
        <p className="booking-text">{t("bookingPreviewText")}</p>
        <Link to="/contact" className="btn-primary">
          {t("navBookMe")}
        </Link>
      </section>

      <Footer />
    </>
  );
};

export default Home;
